import React, { useState } from "react";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Input } from "antd";
import ButtonLayout from "../../common/layoutButton";
import appconstant from "../../themes/appconstant";
import images from "../../themes/appImage";
import { useDispatch } from "react-redux";
import { changePasswordLoad, skipApiLoad } from "../../redux/slices/auth.slice";
import { skipApi } from "../../redux/Api/api";

const ChangePassword = () => {
  const dispatch = useDispatch();
  const initialValues = {
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  };

  const validationSchema = Yup.object().shape({
    oldPassword: Yup.string().required("Old password is required"),
    newPassword: Yup.string()
      .required("New password is required")
      .min(8, "Password must be at least 8 characters long")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(/[0-9]/, "Password must contain at least one number")
      .matches(/[\W_]/, "Password must contain at least one special character"),
    confirmNewPassword: Yup.string()
      .required("Confirm new password is required")
      .oneOf([Yup.ref("newPassword")], "Passwords must match"),
  });

  const skipFunction = () => {
    dispatch(skipApiLoad());
  };

  const handleSubmit = (values) => {
    dispatch(
      changePasswordLoad({
        oldPassword: values.oldPassword,
        password: values.newPassword,
      })
    );
  };

  return (
    <div className="w-[100vw] h-[100vh] bg-background flex flex-col items-center justify-between">
      <div className="max-w-[424px] max-h-[455px] flex items-center flex-col mt-5">
        <img className="mb-5" src={images.appLogo} alt="metafit-logo" />
        <button
          onClick={skipFunction}
          className={` absolute w-[120px] right-4 h-[48px] py-[12px] px-[18px] bg-purple-gradient rounded-[56px] flex justify-center items-center shadow-button-shadow `}
        >
          <div className="text-white text-[20px] font-semibold">Skip</div>
        </button>
        <div className="w-full bg-white border shadow-metafit-shadow rounded-lg p-5 md:p-2 sm:w-[100vw]">
          <div className="text-2xl font-semibold text-dark text-center my-4">
            Change Password
          </div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            <Form className="max-w-sm mx-auto">
              <div className="mb-5 relative">
                <label
                  htmlFor="oldPassword"
                  className="block mb-2 text-sm font-[400] text-dark"
                >
                  Old Password
                  <span className="text-[#D33030]">*</span>
                </label>
                <Field name="oldPassword">
                  {({ field }) => (
                    <Input.Password
                      {...field}
                      id="oldPassword"
                      autoComplete="off"
                      style={{ borderRadius: "10px", height: "45px" }}
                      placeholder="Enter your old password"
                    />
                  )}
                </Field>
                <ErrorMessage
                  name="oldPassword"
                  component="div"
                  className="text-red-500 text-xs font-normal"
                />
              </div>

              <div className="mb-5 relative">
                <label
                  htmlFor="newPassword"
                  className="block mb-2 text-sm font-[400] text-dark"
                >
                  New Password
                  <span className="text-[#D33030]">*</span>
                </label>
                <Field name="newPassword">
                  {({ field }) => (
                    <Input.Password
                      {...field}
                      id="newPassword"
                      autoComplete="off"
                      style={{ borderRadius: "10px", height: "45px" }}
                      placeholder="Enter your new password"
                    />
                  )}
                </Field>
                <ErrorMessage
                  name="newPassword"
                  component="div"
                  className="text-red-500 text-xs font-normal"
                />
              </div>

              <div className="mb-5 relative">
                <label
                  htmlFor="confirmNewPassword"
                  className="block mb-2 text-sm font-[400] text-dark"
                >
                  Confirm New Password
                  <span className="text-[#D33030]">*</span>
                </label>
                <Field name="confirmNewPassword">
                  {({ field }) => (
                    <Input.Password
                      {...field}
                      id="confirmNewPassword"
                      autoComplete="off"
                      style={{ borderRadius: "10px", height: "45px" }}
                      placeholder="Confirm your new password"
                    />
                  )}
                </Field>
                <ErrorMessage
                  name="confirmNewPassword"
                  component="div"
                  className="text-red-500 text-xs font-normal"
                />
              </div>

              <div className="mb-5 flex gap-2">
                {/* <ButtonLayout text="skip" className="login-btn" type="submit" /> */}
                <ButtonLayout
                  text="update"
                  className="login-btn"
                  type="submit"
                />
              </div>
            </Form>
          </Formik>
        </div>
      </div>
      <div className="text-sm font-normal text-light mb-3">
        {appconstant.metafitRights}
      </div>
    </div>
  );
};

export default ChangePassword;
